<template>
  <div class="access-denied">
    <v-card class="mx-auto access-denied-card">
      <div class="access-denied-content mb-10">
        <img
          class="webinarinc-logo"
          id="company-logo"
          src="https://webinarinc-central.s3.us-west-1.amazonaws.com/public/company_logo/revdojo_logo.png"
        />

        <div class="mt-5 text-left">
          <h2 class="mt-3 mb-3 text-center">{{ title }}</h2>
          <br />
          <p>Hi {{ userName }},</p>
          <p v-if="isNoAppAccess">
            You don't have permission to access the
            <b>{{ appName }}</b> application.
          </p>
          <p v-if="isUnderReview">
            We'll review your registration and if we can confirm it, you'll be
            able to access your account within approximately 24 hours.
          </p>
          <p v-if="isRejected">
            Your account has been <b>rejected</b> and you do not have access to
            our application.
          </p>
          <p v-if="isInactive">
            To reactivate your account,
            <b>please contact your account administrator</b> and request to
            reactivate your account.
          </p>

          <p v-if="isDeletedUser">
            Your account has been <b>deleted</b>. If you would like to retrieve
            your deleted account.
          </p>

          Please send an email to
          <a
            class="subtitle-2 text-red-600"
            href="mailto:support@revdojo.com"
            target="_blank"
          >
            support@revdojo.com
          </a>
          if you have any concerns.
        </div>
      </div>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="goBack()" id="go-back-btn" class="mt-5" color="#DC3522">
          Go Back to Login
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appNameDefault: 'Mystery Shop',
    };
  },
  computed: {
    appName() {
      return this.$route.query.app_name
        ? this.$route.query.app_name
        : this.appNameDefault;
    },
    error() {
      return this.$route.query.error;
    },
    userName() {
      return this.$route.query.user_name;
    },
    userCentralId() {
      return this.$route.query.user_central_id;
    },
    isNoAppAccess() {
      return this.error == 'no_app_access';
    },
    isDeletedUser() {
      return this.error == 'deleted_user';
    },
    isUnderReview() {
      return this.error == 'UNDER_REVIEW';
    },
    isInactive() {
      return this.error == 'INACTIVE';
    },
    isRejected() {
      return this.error == 'REJECTED';
    },
    title() {
      if (this.isNoAppAccess || this.isRejected) {
        return 'Access Denied';
      }

      if (this.isUnderReview) {
        return 'Thanks for providing your information';
      }

      if (this.isInactive) {
        return 'Your account has been deactivated';
      }

      if (this.isDeletedUser) {
        return 'Your account has been deleted';
      }

      return 'Hello';
    },
  },
  mounted() {
    if (this.error == 'User did not authorize the request') {
      this.goBack();
    }

    const params = [
      'error_type',
      'error',
      'app_name',
      'user_name',
      'user_central_id',
    ];

    if (!params.every((key) => Object.keys(this.$route.query).includes(key))) {
      this.goBack();
    }
  },
  methods: {
    goBack() {
      this.$http
        .get('/okta/get-logout-link', {
          params: {
            user_central_id: this.userCentralId,
          },
        })
        .then(({ data }) => {
          this.$auth.logout();
          localStorage.removeItem('nextUrl');
          window.location.href = data;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.access-denied
    height: 100vh;
    display: flex;
    align-items: center;

    .access-denied-card
        width: 30rem;
        height: auto

        .access-denied-content
            text-align: center
            margin: 1rem

.webinarinc-logo
    width: auto;
    height: 6rem;

#go-back-btn
    color: white !important
</style>
